import AbstractProvidedClass from "../../../shared/AbstractProvidedClass";

export default class ReshapePolyShapeAction extends AbstractProvidedClass {
    movedX = 0;
    movedY = 0;

    constructor(provider, elementPart) {
        super(provider);

        this.elementPart = elementPart;

        if (this.settings.snapToGrid) {
            this.prevX = this.view.currentX;
            this.prevY = this.view.currentY;
        }
    }

    update() {
        let moveX, moveY;
        if (this.settings.snapToGrid) {
            [moveX, moveY] = this.view.snappedCoordinate.diff(this.elementPart);
        } else {
            moveX = this.p.movedX / this.view.scale;
            moveY = this.p.movedY / this.view.scale;
        }
        if (moveX != 0 || moveY != 0) {
            this.movedX += moveX;
            this.movedY += moveY;
            this.elementPart.drag(moveX, moveY);
        }
    }

    finish() {
        this.movedX == 0 && this.movedY == 0
            ? this.actions.discard()
            : this.actions.finish();
    }

    undo() {
        this.elementPart.drag(-this.movedX, -this.movedY);
    }

    redo() {
        this.elementPart.drag(this.movedX, this.movedY);
    }

    private

    calculateShift(prevPos, currentPos) {
        let step = (currentPos - prevPos) / this.grid.minorSize;

        if (Math.abs(step) < 1) {
            return 0;
        }

        step = step > 0 ? Math.floor(step) : Math.ceil(step);
        return step * this.grid.minorSize;
    }
}
